<div class="flex-stretch flexcol lg-sidebar-panel-scrollable lg-sidebar-panel-scrollable--full">
    <div
        lgScrollable
        [lgScrollableWrapper]="false"
        lgScrollbarClass="lg-scrollbar lg-scrollbar--sidebar"
        class="flex-stretch"
        lgArrowNavigation
        [horizontalNavigation]="false"
    >
        @for (navNode of _navigation; track $index) {
            <lg-sidebar-menu-item
                [currentUrl]="_currentUrl"
                [navNode]="navNode"
                [matchChildrenByQueryParams]="navNode.matchChildrenByQueryParams"
                [sidebar]="sidebar"
                (navigate)="_navigate($event)"
            ></lg-sidebar-menu-item>
        }
    </div>
</div>
